/*
 Show / Hide menu on scroll up/down

 Kudos: https://dev.to/areeburrub/hide-navbar-as-scroll-down-in-less-than-10-lines-of-javascript-1i00
 (Modified by Knowit)
 */

let lastScrollTop;
const targetID = 'menu--hide-on-scroll';
const navbar = document.getElementById(targetID);
if (navbar) {
  navbar.style.transition = 'all .3s';
  navbar.style.position = 'sticky';
}
const navbarLogo = document.getElementById('lillan-show__top-center_logo');
const mainLogo = document.getElementById('main-header-logo');

window.addEventListener('scroll', function() {
  // Check if navbar exists
  if (!navbar) {
    return; // Exit if navbar is not defined
  }

  // Defer the execution of onscroll handler by wrapping it's code inside a zero-length timeout,
  // which effectively moves the execution of that piece of code to the end of current execution stack.
  // Kudos: https://stackoverflow.com/questions/45635008/how-can-i-prevent-onscroll-function-to-trigger-during-resize
  setTimeout(function() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let topOffset = navbar.offsetHeight || 0;

    // Check if mainLogo exists
    if (!mainLogo) {
      console.warn('Main logo element not found');
      return; // Exit if mainLogo is not defined
    }

    let mainLogoHeight = mainLogo.offsetHeight;

    if (scrollTop > lastScrollTop) {
      navbar.style.top = '-' + topOffset + 'px';
      //console.log('scrolling down');

      // if (scrollTop > mainLogoHeight) {
      // 	mainLogo.style.opacity = 0;
      // }

      // Show/Hide the secondary logo if main logo is on/off screen
      // if (scrollTop < mainLogoHeight) {
      // 	navbarLogo.style.opacity = 0;
      // }
      // else {
      // 	navbarLogo.style.opacity = 1;
      // }
    }
    else {
      navbar.style.top = '0';
      //console.log('scrolling up');

      // Show/Hide the secondary logo if main logo is on/off screen
      // if (scrollTop > ( topOffset + mainLogoHeight )) {
      // 	navbarLogo.style.opacity = 1;
      // }
      // else {
      // 	navbarLogo.style.opacity = 0;
      //
      // }
      //
      // if (scrollTop < mainLogoHeight) {
      // 	mainLogo.style.opacity = 1;
      // }
    }
    lastScrollTop = scrollTop;

  }, 0);
});
